import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

// @mui icons
import Icon from "@mui/material/Icon";

const menus = (): CloudPremisePluginMenu[] => {
    return [
        {
            type: "collapse",
            name: "Dashboards",
            key: "dashboards",
            icon: <Icon fontSize="medium">dashboard</Icon>,
            privacy: "private",
            collapse: [
              {
                name: "Analytics",
                key: "analytics",
                route: "/dashboards/analytics",
              },
              {
                name: "Sales",
                key: "sales",
                route: "/dashboards/sales",
              },
            ],
        },
        {
            type: "collapse",
            name: "Pages",
            key: "pages",
            icon: <Icon fontSize="medium">image</Icon>,
            privacy: "private",
            collapse: [
                {
                    name: "Profile",
                    key: "profile",
                    collapse: [
                    {
                        name: "Profile Overview",
                        key: "profile-overview",
                        route: "/pages/profile/profile-overview",
                    },
                    {
                        name: "All Projects",
                        key: "all-projects",
                        route: "/pages/profile/all-projects",
                    },
                    ],
                },
                {
                    name: "Users",
                    key: "users",
                    collapse: [
                    {
                        name: "New User",
                        key: "new-user",
                        route: "/pages/users/new-user",
                    },
                    ],
                },
                {
                    name: "Account",
                    key: "account",
                    collapse: [
                    {
                        name: "Settings",
                        key: "settings",
                        route: "/pages/account/settings",
                    },
                    {
                        name: "Billing",
                        key: "billing",
                        route: "/pages/account/billing",
                    },
                    {
                        name: "Invoice",
                        key: "invoice",
                        route: "/pages/account/invoice",
                    },
                    ],
                },
                {
                    name: "Projects",
                    key: "projects",
                    collapse: [
                    {
                        name: "Timeline",
                        key: "timeline",
                        route: "/pages/projects/timeline",
                    },
                    ],
                },
                {
                    name: "Pricing Page",
                    key: "pricing-page",
                    route: "/pages/pricing-page",
                },
                { name: "RTL", key: "rtl", route: "/pages/rtl" },
                { name: "Widgets", key: "widgets", route: "/pages/widgets" },
                { name: "Charts", key: "charts", route: "/pages/charts" },
                {
                    name: "Notfications",
                    key: "notifications",
                    route: "/pages/notifications",
                },
            ],
        },
        {
            type: "collapse",
            name: "Applications",
            key: "applications",
            icon: <Icon fontSize="medium">apps</Icon>,
            privacy: "private",
            collapse: [
                {
                    name: "Kanban",
                    key: "kanban",
                    route: "/applications/kanban",
                },
                {
                    name: "Wizard",
                    key: "wizard",
                    route: "/applications/wizard",
                },
                {
                    name: "Data Tables",
                    key: "data-tables",
                    route: "/applications/data-tables",
                },
                {
                    name: "Calendar",
                    key: "calendar",
                    route: "/applications/calendar",
                },
            ],
        },
        {
            type: "collapse",
            name: "Ecommerce",
            key: "ecommerce",
            icon: <Icon fontSize="medium">shopping_basket</Icon>,
            privacy: "private",
            collapse: [
                {
                    name: "Products",
                    key: "products",
                    collapse: [
                        {
                            name: "New Product",
                            key: "new-product",
                            route: "/ecommerce/products/new-product",
                        },
                        {
                            name: "Edit Product",
                            key: "edit-product",
                            route: "/ecommerce/products/edit-product",
                        },
                        {
                            name: "Product Page",
                            key: "product-page",
                            route: "/ecommerce/products/product-page",
                        },
                    ],
                },
                {
                    name: "Orders",
                    key: "orders",
                    collapse: [
                        {
                            name: "Order List",
                            key: "order-list",
                            route: "/ecommerce/orders/order-list",
                        },
                        {
                            name: "Order Details",
                            key: "order-details",
                            route: "/ecommerce/orders/order-details",
                        },
                    ],
                },
            ],
        },
        {
            type: "collapse",
            name: "Authentication",
            key: "authentication",
            icon: <Icon fontSize="medium">content_paste</Icon>,
            privacy: "public",
            collapse: [
                {
                    name: "Sign In",
                    key: "sign-in",
                    collapse: [
                        {
                            name: "Basic",
                            key: "basic",
                            route: "/authentication/sign-in/basic",
                        },
                        {
                            name: "Cover",
                            key: "cover",
                            route: "/authentication/sign-in/cover",
                        },
                        {
                            name: "Illustration",
                            key: "illustration",
                            route: "/authentication/sign-in/illustration",
                        },
                    ],
                },
                {
                    name: "Sign Up",
                    key: "sign-up",
                    collapse: [
                        {
                            name: "Cover",
                            key: "cover",
                            route: "/authentication/sign-up/cover",
                        },
                    ],
                },
                {
                    name: "Reset Password",
                    key: "reset-password",
                    collapse: [
                        {
                            name: "Cover",
                            key: "cover",
                            route: "/authentication/reset-password/cover",
                        },
                    ],
                },
            ],
        },
    ];
};

export default menus;